export class WorkType {
  WorkType;
  EDesc;
  CDesc;
  AddBy;
  constructor() {
    this.WorkType = "";
    this.EDesc = "";
    this.CDesc = "";
    this.AddBy = "";
  }
}



// WEBPACK FOOTER //
// ./src/model/WorkType.js